import { lazy } from 'react';

export const Home = lazy(() => import('./home'));

// export const Defaulthome = lazy(() => import('./defaulthome'));

// export const Permisshome = lazy(() => import('./permisshome'));